import { Link, useLocation } from 'react-router-dom';
import { Phone } from 'lucide-react';
import { CONTACT } from './content';
import { NAV, navHref } from './nav';
import { Container } from './ui';

export const PublicFooter = () => {
	const onHome = useLocation().pathname === '/';
	const links = NAV.filter(n => n.hash !== 'arxiki');

	return (
		<footer className='border-t border-(--dm-line) bg-white'>
			<Container className='grid gap-10 py-14 md:grid-cols-[1.2fr_2fr]'>
				<div>
					<Link to='/' aria-label='DeliveryMan — αρχική' className='inline-block'>
						<img
							src='/images/logo_rect.png'
							alt='DeliveryMan'
							width={1419}
							height={319}
							loading='lazy'
							decoding='async'
							className='h-9 w-auto'
						/>
					</Link>
					<p className='mt-4 max-w-xs text-[15px] leading-relaxed text-(--dm-muted)'>
						Η πλατφόρμα που οργανώνει το delivery για καταστήματα, διανομείς και στόλους.
					</p>
					<a
						href={`tel:${CONTACT.phone}`}
						className='mt-5 inline-flex items-center gap-2 text-base font-bold text-(--dm-navy) hover:text-(--dm-blue)'
					>
						<Phone size={18} aria-hidden='true' />
						{CONTACT.phoneDisplay}
					</a>
				</div>

				<nav aria-label='Σύνδεσμοι υποσέλιδου'>
					<ul className='grid grid-cols-2 gap-x-6 gap-y-3 sm:grid-cols-3'>
						{links.map(item => (
							<li key={item.label}>
								{item.to ? (
									<Link
										to={item.to}
										className='text-[15px] text-(--dm-muted) transition-colors hover:text-(--dm-navy)'
									>
										{item.label}
									</Link>
								) : (
									<a
										href={navHref(item, onHome)}
										className='text-[15px] text-(--dm-muted) transition-colors hover:text-(--dm-navy)'
									>
										{item.label}
									</a>
								)}
							</li>
						))}
					</ul>
				</nav>
			</Container>

			<div className='border-t border-(--dm-line)'>
				<Container className='flex flex-col items-center justify-between gap-3 py-6 text-sm text-(--dm-muted) sm:flex-row'>
					<p>© {new Date().getFullYear()} DeliveryMan</p>
					<div className='flex flex-wrap justify-center gap-x-6 gap-y-2'>
						<a href='/docs' target='_blank' rel='noopener' className='hover:text-(--dm-navy)'>
							Τεκμηρίωση API
						</a>
						<Link to='/terms' className='hover:text-(--dm-navy)'>
							Όροι χρήσης
						</Link>
						<Link to='/politiki-aporritou' className='hover:text-(--dm-navy)'>
							Πολιτική απορρήτου
						</Link>
					</div>
				</Container>
			</div>
		</footer>
	);
};
